import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../../utils/Methods";
import { IDS } from "../../../../../utils/IDS";



export const FestivalRegistrations = createAsyncThunk(
  "common/masters/FestivalRegistrations",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Festival}?name=${filter?.name || ""}&email=${filter?.email || ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}&owner_id=${filter?.owner_id || ""}&room_id=${filter?.room_id || ""}`);
      if (res?.data?.success) {
        return res.data
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
//  Get All
export const GetAll = createAsyncThunk(
  "masters/festival/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Festival}?term=${filter?.name || ""}` +
        `&festival_category_id=${filter?.festival_category_id || ""}` +
        `&festival_type_id=${filter?.festival_type_id || ""}` +
        `&startDate=${filter?.start_date || ""}` +
        `&endDate=${filter?.end_date || ""}` +
        `&page=${filter?.page || IDS.PAGE}` +
        `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllActive = createAsyncThunk(
  "masters/festival/get-all-active",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Festival}/all-active-festivals?term=${filter?.name || ""}` +
        `&festival_category_id=${filter?.festival_category_id || ""}` +
        `&festival_type_id=${filter?.festival_type_id || ""}` +
        `&startDate=${filter?.start_date || ""}` +
        `&endDate=${filter?.end_date || ""}` +
        `&page=${filter?.page || IDS.PAGE}` +
        `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllCompleted = createAsyncThunk(
  "masters/festival/get-all-completed",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Festival}/all-completed-festivals?term=${filter?.name || ""}` +
        `&festival_category_id=${filter?.festival_category_id || ""}` +
        `&festival_type_id=${filter?.festival_type_id || ""}` +
        `&startDate=${filter?.start_date || ""}` +
        `&endDate=${filter?.end_date || ""}` +
        `&page=${filter?.page || IDS.PAGE}` +
        `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllUpcoming = createAsyncThunk(
  "masters/festival/get-all-upcoming",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Festival}/all-upcoming-festivals?term=${filter?.name || ""}` +
        `&festival_category_id=${filter?.festival_category_id || ""}` +
        `&festival_type_id=${filter?.festival_type_id || ""}` +
        `&startDate=${filter?.start_date || ""}` +
        `&endDate=${filter?.end_date || ""}` +
        `&page=${filter?.page || IDS.PAGE}` +
        `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Get Single
export const GetSingle = createAsyncThunk(
  "masters/festival/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Festival}/${id}`);
      console.log("ressssssfindonefADfgAgdfGgG", res);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//  Create (Add)
export const Create = createAsyncThunk(
  "masters/festival/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Festival, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res); // The new country object
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  Update
export const Update = createAsyncThunk(
  "masters/festival/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.Festival}/${id}`, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  Delete
export const Delete = createAsyncThunk(
  "masters/festival/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.Festival}/${id}`);
      return id; // Return the id of the deleted country
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//  Status
export const Status = createAsyncThunk(
  "masters/festival/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Festival}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const Slice = createSlice({
  name: "festival",
  initialState: {
    data: [],
    active_festivals: [],
    upcoming_festivals: [],
    completed_festivals: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;

      })
      .addCase(GetAll.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;

      })


      .addCase(GetAllActive.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllActive.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.active_festivals = action.payload?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllActive.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      .addCase(GetAllUpcoming.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllUpcoming.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.upcoming_festivals = action.payload?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllUpcoming.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;

      })


      .addCase(GetAllCompleted.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllCompleted.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.completed_festivals = action.payload?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllCompleted.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;

      })




      .addCase(FestivalRegistrations.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;

      })
      .addCase(FestivalRegistrations.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || [];
        state.current_page = action.payload?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.per_page || IDS.PERPAGE;
        state.total = action.payload?.total || IDS.TOTAL;
      })
      .addCase(FestivalRegistrations.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (country) => country.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (country) => country.id !== action.payload.id
        ); // Remove the country with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (country) => country.id !== action.payload.id
        ); // Remove the country with the deleted id
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
